import { GetInhouseTicketSystem as ApiInhouseTicketSystemType } from 'src/api/generated/touring/types';
import { InhouseTicketSystemType } from '../../types';

export const mapInhouseTicketSystemType = (
  apiType: ApiInhouseTicketSystemType
): InhouseTicketSystemType => {
  return {
    ticketSystem: apiType.ticketSystem,
    notes: apiType.notes,
  };
};

